import React from "react";
import { useTranslation } from "react-i18next";
import { useAutoplayError } from "@100mslive/react-sdk";
import { Button, Dialog, Text } from "@100mslive/roomkit-react";
import { DialogContent, DialogRow } from "../../primitives/DialogContent";

export function AutoplayBlockedModal() {
  const { t } = useTranslation();
  const { error, resetError, unblockAudio } = useAutoplayError();
  return (
    <Dialog.Root
      open={!!error}
      onOpenChange={value => {
        if (!value) {
          unblockAudio();
        }
        resetError();
      }}
    >
      <DialogContent
        title={t("lbl_permission_error", "Permission Error")}
        closeable={false}
      >
        <DialogRow>
          <Text variant="md">
            {t(
              "msg_autoplay_audio",
              "The browser wants us to get a confirmation for playing the Audio. Please allow audio to proceed."
            )}
          </Text>
        </DialogRow>
        <DialogRow justify="end">
          <Button
            variant="primary"
            onClick={() => {
              unblockAudio();
              resetError();
            }}
          >
            {t("btn_allow_audio", "Allow Audio")}
          </Button>
        </DialogRow>
      </DialogContent>
    </Dialog.Root>
  );
}
